<div class="mb-3">
  <h5>Current Case Data</h5>
  <div class="report-info-text">
    This report contains the current information about each case in Case
    Management including the current status and the time of the last update.
    This can be filtered by when the cases were updated using the date filter.
  </div>
  <mat-form-field class="me-3">
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input [rangePicker]="picker0">
      <input
        matStartDate
        placeholder="Start date"
        [(ngModel)]="startDateCurrent"
      />
      <input matEndDate placeholder="End date" [(ngModel)]="endDateCurrent" />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker0" />
    <mat-date-range-picker #picker0 />
  </mat-form-field>

  <mat-form-field class="me-3">
    <input
      type="text"
      placeholder="Search For a Unit"
      matInput
      name="unitsControlCurrent"
      [matAutocomplete]="autoCurrent"
      [formControl]="unitsControlCurrent"
      (blur)="checkSelection(unitsControlCurrent)"
    />
    <mat-autocomplete
      #autoCurrent="matAutocomplete"
      (optionSelected)="autoCompleteUnitChanged($event, 'selectedUnitCurrent')"
    >
      @for (unit of filteredUnits; track unit.id) {
        <mat-option [value]="unit.id">
          {{ unit.name }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <button
    type="button"
    mat-raised-button
    color="primary"
    class="mx-auto me-3"
    [disabled]="!selectedUnitCurrent || !startDateCurrent || !endDateCurrent"
    (click)="getCaseManagementReport('CurrentCMCases')"
  >
    Get Report
  </button>
</div>

<div class="mb-3">
  <h5>Historical Case Data</h5>
  <div class="report-info-text">
    This report contains the historical information about each case in Case
    Management. This includes status changes that have been made for each case
    and who the case was assigned to at each point in the review process. This
    can be filtered by when the cases were updated using the date filter.
  </div>
  <mat-form-field class="me-3">
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input [rangePicker]="picker1">
      <input
        matStartDate
        placeholder="Start date"
        [(ngModel)]="startDateHistorical"
      />
      <input
        matEndDate
        placeholder="End date"
        [(ngModel)]="endDateHistorical"
      />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker1" />
    <mat-date-range-picker #picker1 />
  </mat-form-field>

  <mat-form-field class="me-3">
    <input
      type="text"
      placeholder="Search For a Unit"
      matInput
      name="unitsControlHistorical"
      [matAutocomplete]="autoHistorical"
      [formControl]="unitsControlHistorical"
      (blur)="checkSelection(unitsControlHistorical)"
    />
    <mat-autocomplete
      #autoHistorical="matAutocomplete"
      (optionSelected)="
        autoCompleteUnitChanged($event, 'selectedUnitHistorical')
      "
    >
      @for (unit of filteredUnits; track unit.id) {
        <mat-option [value]="unit.id">
          {{ unit.name }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <button
    type="button"
    mat-raised-button
    color="primary"
    class="mx-auto me-3"
    [disabled]="
      !selectedUnitHistorical || !startDateHistorical || !endDateHistorical
    "
    (click)="getCaseManagementReport('HistoricalCMCases')"
  >
    Get Report
  </button>
</div>

<div class="mb-3">
  <h5>Case Management Notes</h5>
  <div class="report-info-text">
    This report contains notes written within each case in Case Management
    including who entered the note and the timestamp for each note. This can be
    filtered by when the cases were updated using the date filter.
  </div>
  <mat-form-field class="me-3">
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input [rangePicker]="picker2">
      <input
        matStartDate
        placeholder="Start date"
        [(ngModel)]="startDateNotes"
      />
      <input matEndDate placeholder="End date" [(ngModel)]="endDateNotes" />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker2" />
    <mat-date-range-picker #picker2 />
  </mat-form-field>

  <mat-form-field class="me-3">
    <input
      type="text"
      placeholder="Search For a Unit"
      matInput
      name="unitsControlNotes"
      [matAutocomplete]="autoNotes"
      [formControl]="unitsControlNotes"
      (blur)="checkSelection(unitsControlNotes)"
    />
    <mat-autocomplete
      #autoNotes="matAutocomplete"
      (optionSelected)="autoCompleteUnitChanged($event, 'selectedUnitNotes')"
    >
      @for (unit of filteredUnits; track unit.id) {
        <mat-option [value]="unit.id">
          {{ unit.name }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <button
    type="button"
    mat-raised-button
    color="primary"
    class="mx-auto me-3"
    [disabled]="!selectedUnitNotes || !startDateNotes || !endDateNotes"
    (click)="getCaseManagementReport('CMNotes')"
  >
    Get Report
  </button>
</div>

<div class="mb-3">
  <h5>Auto-Approved Cases</h5>
  <div class="report-info-text">
    This report contains all cases that have been auto-approved in Case
    Management. This includes cases that have been submitted but do not require
    manual review based on the firm's settings. If all cases require manual
    approval in Case Management, this report will be empty. This can be filtered
    by when the cases were submitted.
  </div>
  <mat-form-field class="me-3">
    <mat-label>Enter a date range</mat-label>
    <mat-date-range-input [rangePicker]="picker3">
      <input
        matStartDate
        placeholder="Start date"
        [(ngModel)]="startDateAutoApproved"
      />
      <input
        matEndDate
        placeholder="End date"
        [(ngModel)]="endDateAutoApproved"
      />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="picker3" />
    <mat-date-range-picker #picker3 />
  </mat-form-field>

  <mat-form-field class="me-3">
    <input
      type="text"
      placeholder="Search For a Unit"
      matInput
      name="unitsControlAutoApproved"
      [matAutocomplete]="autoApproved"
      [formControl]="unitsControlAutoApproved"
      (blur)="checkSelection(unitsControlAutoApproved)"
    />
    <mat-autocomplete
      #autoApproved="matAutocomplete"
      (optionSelected)="
        autoCompleteUnitChanged($event, 'selectedUnitAutoApproved')
      "
    >
      @for (unit of filteredUnits; track unit.id) {
        <mat-option [value]="unit.id">
          {{ unit.name }}
        </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>

  <button
    type="button"
    mat-raised-button
    color="primary"
    class="mx-auto me-3"
    [disabled]="
      !selectedUnitAutoApproved ||
      !startDateAutoApproved ||
      !endDateAutoApproved
    "
    (click)="getCaseManagementReport('AutoApprovedCM')"
  >
    Get Report
  </button>

  <ngx-loading [show]="loading" />
</div>
